import { omitBy, isEmpty } from 'lodash'

import type { ObjectType } from './types'

export const objectOmitEmptyProperties = <DataType>(object: ObjectType): DataType => {
  return omitBy(object, isEmpty) as DataType
}
